

Monet.Maps = {
    defaults: {
        serverUrl: "GetWMSMap",
        format: 'image/png8',
        resolutions: [0.3515625, 0.17578125, 0.087890625, 0.0439453125, 0.02197265625
            , 0.010986328125, 0.0054931640625, 0.00274658203125, 0.001373291015625
            , 6.866455078125E-4, 3.4332275390625E-4, 1.71661376953125E-4
            , 8.58306884765625E-5, 4.291534423828125E-5, 2.1457672119140625E-5
            , 1.0728836059570312E-5, 5.364418029785156E-6, 2.682209014892578E-6],
        open_layers: {
            dotsPerInch: 90.71428571428572,
            onImageLoadErrorColor: 'transparent'

        }

    }
};

/**
 * function marker(settings)
 * @params {Object} settings.latitude,
 *                  settings.longitude,
 *                  settings.map,
 *                  settings.projection,
 *                  settings.stop,
 *                  settings.type
 * @returns {Marker}
 *
 * Cria um Marker pronto para adicionar no mapa
 *
 */
Monet.Maps.Marker = function (settings) {

    if (settings) {
        this.settings = settings;
    } else {
        return false;
    }

    /**
     * function getIcon(type)
     * @params {String} type
     * @returns {String}
     *
     * Valores possíveis "STOP", "ORIGIN", "DESTINATION", "TRUCK"
     *
     * Dependendo do valor passado, será devolvido a URL correta para a imagem do Marker
     */

    this.getIcon = function (type) {

        var icon = "";

        switch (type) {
            case "STOP":
                icon = 'static/images/map/markers/marker_stop_unvisited.png';
                break;
            case "ORIGIN":
                icon = 'static/images/map/markers/origin.png';
                break;
            case "DESTINATION":
                icon = 'static/images/map/markers/marker.png';
                break;
            case "TRUCK":
                icon = 'static/images/map/markers/marker.png';
                break;
            case "PENDING_STOP":
                icon =  'static/images/map/markers/marker_stop_visited.png';
                break;
            default:
                icon = 'static/images/map/markers/marker.png';
        }

        return icon;

    };

    var mkr = new OpenLayers.Marker(
        new OpenLayers.LonLat(
            this.settings.longitude, this.settings.latitude
        ).transform(
                new OpenLayers.Projection(
                    this.settings.projection
                ), this.settings.map.getProjectionObject()
            ), new OpenLayers.Icon(
            this.getIcon(this.settings.type),
            this.settings.size, this.settings.offset));

    return mkr;

};

/**
 * function addMarkerToMap(settings)
 *
 * @params {Object} settings
 * @returns {This}
 *
 * Instancia um novo Marker, adiciona ao layer passado e atribui ações a ele
 */
Monet.Maps.addMakerToMap = function (settings) {

    if (settings) {
        return false;
    }

    marker = Monet.Maps.Marker({
        size: settings.size,
        latitude: settings.latitude,
        longitude: settings.longitude,
        offset: settings.offset,
        projection: settings.projection,
        stop: settings.stop,
        map: settings.map,
        type: settings.type
    });

    settings.layer.addMarker(marker);

    marker.events.register('mouseover', marker, function (evt) {

        settings.callback(settings.stop);

        OpenLayers.Event.stop(evt);
    });

    return this;

};


Monet.Maps.Updater = function () {
    this.route = function () {
        const routeRouter = App.Objects.RouteSummaryRoutes;
        const resetCollection = false;
        const updater = App.Forms.RouteSummaryRoutes.controlUpdater;
        const action = 'update';
        routeRouter.updateGrid(routeRouter.getFilter(), updater.updateDataToGrid, resetCollection, action);
    };

    this.stop = function () {
        var stopRouter = App.Objects.RouteSummaryStops;
        var resetCollection = false;
        var updater = App.Forms.RouteSummaryStops.controlUpdater;
        var action = 'update';
        stopRouter.updateGrid(stopRouter.getFilter(), updater.updateDataToGrid, resetCollection, action);
    };

    this.order = function () {
        const orderRouter = App.Objects.RouteSummaryOrders;
        const resetCollection = false;
        const updater = App.Forms.RouteSummaryOrders.controlUpdater;
        const action = 'update';
        orderRouter.updateGrid(orderRouter.getFilter(), updater.updateDataToGrid, resetCollection, action);
    };


    this.updatePendingOrderOnTheMap = function () {
        var mapLayer = new Greenmile.Toolbar.MapLayerActions.PendingOrders();
        mapLayer.map = Monet.Session.Maps.map;
        mapLayer.getPendingOrdersAndShowOnTheMap();
    };

    this.go = function () {

        console.log('['+ new Date().toISOString() + '] Starting update maps data.');

        App.Objects.RouteDetails.processMapUpdates();

        if (GreenmileTabPanel.getActiveTab() === 'RouteMonitor') {
          if (Monet.Session.mainMap && Monet.Session.mainMap.map) {
              const mainMapZoom = Monet.Session.mainMap.map.getZoom();
              const mainMapLatLng = Monet.Session.mainMap.map.getCenter();
              const mapStorage = new Greenmile.Storage.StoreMapPosition();
              mapStorage.setPosition(mainMapLatLng, mainMapZoom);
              App.Objects.RouteMonitor.getEquipmentPositionsByOrganizations();
              App.Routers.RouteMonitor.prototype.layerFocus.clearLayers();
              GreenmileReduxStore.dispatch({
                type: 'GREENMILE_ROUTEMONITOR_UPDATE_PENDING_ORDERS_ROW'
              });
          }
        }
    };
};
